import React, { useEffect } from "react";
import BrandPerformanceTrendTile from "../BrandPerformanceTrendTile";
import BrandPerformanceTableTile from "../BrandPerformanceTableTile";
import { RouteComponentProps, withRouter } from "react-router-dom";
import { isNull, isNullOrUndefined } from "../../../../utils/utilityFunctions";
import { RootStateOrAny, useSelector } from "react-redux";
import { useQuery } from "@tanstack/react-query";
import { getRVTableData, getRVTrendData } from "../../../../api";

interface Props extends RouteComponentProps {
  diff: number;
  granularity: string;
}

const RvContent = withRouter((props: Props) => {
  const { diff, history, granularity } = props;

  const params = useSelector((state: RootStateOrAny) => state.parameters);

  // fetch the trend and average data
  const {
    data: chartData,
    isFetching: loadingTrend, // call data using react-query
    refetch: refetchRVTrend,
  } = useQuery(["rvTrendData", granularity, history.location.search], () => getRVTrendData({ ...params }), { enabled: false });

  const {
    data: tableData,
    isFetching: loadingTable,
    refetch: refetchRVAverage,
  } = useQuery(["rvTableData", granularity, history.location.search], () => getRVTableData({ ...params }), {
    enabled: false,
  });

  // when the url changes, refetch the data
  useEffect(() => {
    refetchRVAverage();
    refetchRVTrend();
  }, [history.location.search]);

  const nestedTableRowStyle = { display: "flex", justifyContent: "center", border: 0 };

  const columns = [
    {
      id: "model",
      Header: `Model`,
      accessor: "model",
      defaultCanSort: true,
      sortDescFirst: true,
      sortType: "alphanumericIgnoreCase",
      Cell: (props: { value: string }) => {
        const { value } = props;

        return value;
      },
    },
    {
      Header: "Model Year",
      accessor: `model_year`,
      id: "modelYear",
      defaultCanSort: true,
      defaultSortDesc: true,
      sortDescFirst: true,
      sortType: "alphanumericCustom",
      Cell: ({ value }: { value: string[] }) => {
        return (
          <>
            {value?.map((item, index) => (
              <tr key={index} style={nestedTableRowStyle}>
                <td>{item}</td>
              </tr>
            ))}
          </>
        );
      },
    },
    {
      Header: "RV",
      accessor: `model_score`,
      id: "rv",
      defaultCanSort: true,
      defaultSortDesc: true,
      sortDescFirst: true,
      sortType: "alphanumericCustom",
      Cell: ({ value }: { value: string[] }) => {
        return (
          <>
            {value?.map((item, index) => (
              <tr key={index} style={nestedTableRowStyle}>
                <td>{!isNullOrUndefined(item) ? `${item}%` : "N/A"}</td>
              </tr>
            ))}
          </>
        );
      },
    },
  ];

  return (
    <div className="brand-market-main-content">
      <BrandPerformanceTrendTile
        title="RV Trend"
        chartId="rvTrendChart"
        chartData={chartData}
        loadingTrend={loadingTrend}
        diff={diff}
        chartGranularity={granularity}
        isPercentage={true}
        noValueAxisMin={true}
      />
      <BrandPerformanceTableTile
        title="RV by Model Year"
        tableId="rvTable"
        tableData={tableData}
        columns={columns}
        loadingTable={loadingTable}
        initialSortCol={{ id: "model", desc: true }}
        nestedInData={false}
      />
    </div>
  );
});

export default RvContent;

const mock = [
  {
    model: "Altima",
    model_year: ["2021", "2022", "2023"],
    model_score: [80, 70, 30],
  },
];
